export { default } from "./ChevronThinRightIcon";
